import styled, { css } from "styled-components";
import media from "@kiwicom/orbit-components/lib/utils/mediaQuery";

export const Content = styled.div`
  z-index: 3;
  margin-top: -130px;
  padding: 48px 0;

  ${media.tablet(css`
    padding: 48px 16px;
  `)}
`;

export const Image = styled.img`
  width: 100%;
  height: 40vh;
  object-fit: cover;
`;

export const Link = styled.a`
  font-size: 24px;
  color: rgb(138, 23, 26);
`;
